//現在のページ数規定値
export const CURRENT_PAGE = {
    FIRST: 1,
    SECOND: 2,
    THIRD: 3
}

